// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_fuZ","cls2":"shared-cls2_dRb shared-cls1_fuZ"};